import { axios } from '../../services/axios';

export default function getGCCHServiceProfileDialPlans({ scope }) {
    return axios.get(
        `/ServiceProfiles/DirectRoutingGCCH/${scope}/DialPlans/Available`,
    );
}
